// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5131":"320998fb","7034":"210f95f9"}[chunkId] || chunkId) + "." + {"2144":"7a1e4e4b8f552776","5131":"89bece7c1c7df977","7034":"aa58d41ff9932c69","7735":"7ca85e4cbf8986c9","8447":"a356f9b10b768fba"}[chunkId] + ".js";
};